<template>
    <el-container>
      <el-aside width="350px"></el-aside>
      <el-main>
        <el-row :gutter="20">
          <h1 style="color:black;font-size: 30px;"><i class="el-icon-s-marketing" style="margin-right:5px;color: #077676;font-weight: bold;"></i>Developmental process</h1>
        </el-row>
        <el-row :gutter="20">
          <el-collapse v-model="activeNames" accordion>
          </el-collapse>
        </el-row>
      </el-main>
      <el-aside width="350px"></el-aside>
    </el-container>
  </template>
  
  <script>
  
  export default {
    components: {
  },
    data() {
      return {
        activeNames: ['6'],
      };
    },
  }
  </script>
  
  <style>
  .el-row{
    margin-bottom: 50px;
  }
  .el-collapse-item {
    margin-bottom: 20px;
  }
  .el-collapse-item__header {
    background-color: #48869d;
    font-size: large;
    color: white;
  }
  .demo-form-inline {
    font-weight: bold;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }
  .analysis-button {
    font-size: medium;
    float: left;
    background-color: #1679c6;
    width: 100px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/search/Multi.vue